/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import { ChevronDown, ChevronRight, Info } from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { bindActionCreators } from "redux";

import "./styles.css";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import ContentLessonPlans from "../../../../components/LessonPlans";
import Loading from "../../../../components/Loading";
import DropdownCard from "../../../../components/PedagogicalFollowUps/DropdownCard";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ExecutionRoomPedagogicalFollowUps extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      saving: false,
      isCardCollapsed: false,
      allocationInfo: null,
      students: [],
      thematicUnits: [],
      itemsWithoutAbility: [],
      studentsAnswers: {},
      isViewOnlyMode: false,
      allocationId: null,
      roomId: null,
      followUpId: null,
      // Novos estados para PCD e Alfabetizado
      studentPCDInfo: {}, // { studentId: { pcd: true/false, cid: null/string } }
      studentAlfabetizadoInfo: {}, // { studentId: true/false }
      updatingStudentPCD: {}, // { studentId: true/false }
      updatingStudentAlfabetizado: {}, // { studentId: true/false }
      // Modal PCD
      showPCDModal: false,
      showCIDInput: false,
      cidValue: "",
      currentPCDStudent: null,
      studentHasReportInfo: {}
    };
  }

  componentDidMount() {
    this.loadData();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.setupHorizontalScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    this.removeHorizontalScroll();
  }

  setupHorizontalScroll = () => {
    this.handleWheel = e => {
      if (e.altKey) {
        e.preventDefault();
        const container = document.querySelector(".table-scroll-container");
        if (container) {
          const scrollAmount = e.deltaY > 0 ? 100 : -100;
          container.scrollLeft += scrollAmount;
        }
      }
    };

    document.addEventListener("wheel", this.handleWheel, { passive: false });
  };

  removeHorizontalScroll = () => {
    if (this.handleWheel) {
      document.removeEventListener("wheel", this.handleWheel);
    }
  };

  handleResize = () => {
    const isMobile = window.innerWidth < 768;
    if (isMobile && !this.state.isCardCollapsed) {
      this.setState({ isCardCollapsed: true });
    } else if (!isMobile && this.state.isCardCollapsed) {
      this.setState({ isCardCollapsed: false });
    }
  };

  loadAllocationInfo = async allocationId => {
    try {
      const params = new URLSearchParams();
      params.append("allocation_ids[]", allocationId);

      const url = `${
        URL.api
      }pedagogical/follow-ups/allocations/information?${params.toString()}`;

      const response = await axios.get(url, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      });

      if (response.data?.success) {
        if (response.data?.data?.allocations?.length > 0) {
          const allocation = response.data.data.allocations[0];

          this.setState({
            allocationInfo: {
              id: allocation.allocation_id,
              name: allocation.follow_up_name,
              room_name: allocation.room_name,
              school_name: allocation.school_name,
              discipline_name: allocation.discipline_name,
              start_date: allocation.start_date,
              end_date: allocation.end_date,
              month: allocation.month,
              year: allocation.year
            },
            roomId: allocation.room_id,
            followUpId: allocation.follow_up_id
          });

          return {
            roomId: allocation.room_id,
            followUpId: allocation.follow_up_id
          };
        }
        console.error("❌ allocations array vazio ou inexistente");
        throw new Error("Nenhuma alocação encontrada");
      } else {
        console.error("❌ success = false");
        console.error("❌ Mensagem:", response.data?.message);
        throw new Error(response.data?.message || "Resposta sem sucesso");
      }
    } catch (error) {
      console.error("❌ ERRO em loadAllocationInfo:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        headers: error.response?.headers
      });
      toastr.error(
        "Erro",
        `Erro ao carregar alocação: ${
          error.response?.data?.message || error.message
        }`
      );
      throw error;
    }
  };

  loadQuestionList = async followUpId => {
    const response = await axios.get(
      `${URL.api}pedagogical/follow-ups/${followUpId}/question-list`,
      { headers: { authorization: `Bearer ${this.props.user.token}` } }
    );

    if (response.data?.success) {
      const thematicUnitsData = response.data.data.thematic_units || [];
      const itemsWithoutAbilityData =
        response.data.data.items_without_ability || [];

      this.setState({
        thematicUnits: thematicUnitsData,
        itemsWithoutAbility: itemsWithoutAbilityData
      });

      return thematicUnitsData;
    }

    return [];
  };

  loadRoomExecutions = async (allocationId, thematicUnits) => {
    try {
      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/room-executions`,
        {
          params: { allocation_id: allocationId },
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      console.log("📡 Resposta da API room-executions:", response.data);

      // Inicializar respostas padrão para todos os alunos
      const initialAnswers = {};

      if (this.state.students.length > 0 && thematicUnits.length > 0) {
        // PASSO 1: Inicializar TODOS os alunos com "nao-avaliado"
        this.state.students.forEach(student => {
          const studentId = student.student_id;
          initialAnswers[studentId] = {};

          thematicUnits.forEach(unit => {
            (unit.items || []).forEach(item => {
              initialAnswers[studentId][item.ability_code] = "nao-avaliado";
            });
          });
        });

        console.log("📊 Estado inicial (todos nao-avaliado):", initialAnswers);

        // PASSO 2: Preencher com respostas existentes da API
        if (response.data?.success) {
          const studentsAnswersData = response.data.data.students_answers || [];

          console.log(
            `📊 Encontrados ${studentsAnswersData.length} alunos com execuções salvas`
          );

          studentsAnswersData.forEach(studentAnswer => {
            const studentId = studentAnswer.student_id;

            console.log(`\n📋 Processando aluno ID: ${studentId}`);
            console.log(`   - PCD: ${studentAnswer.pcd}`);
            console.log(`   - Alfabetizado: ${studentAnswer.is_literate}`);
            console.log(
              `   - Total de respostas: ${studentAnswer.answers?.length || 0}`
            );

            if (studentAnswer.answers && studentAnswer.answers.length > 0) {
              studentAnswer.answers.forEach(answer => {
                // Encontrar a habilidade pelo item_id
                let foundHabilidadeCodigo = null;
                let foundOptionId = null;

                for (const unit of thematicUnits) {
                  const item = unit.items?.find(
                    i => i.item_id === answer.item_id
                  );
                  if (item) {
                    foundHabilidadeCodigo = item.ability_code;
                    // Encontrar a opção pelo option_id já vindo na resposta
                    const option = item.options?.find(
                      o => o.id === parseInt(answer.option_id)
                    );
                    if (option) {
                      foundOptionId = option.id;
                    }
                    break;
                  }
                }

                if (foundHabilidadeCodigo && foundOptionId) {
                  console.log(`   - Habilidade: ${foundHabilidadeCodigo}`);
                  console.log(`     - option_id: ${foundOptionId}`);
                  // Armazenar diretamente o option_id
                  initialAnswers[studentId][foundHabilidadeCodigo] =
                    String(foundOptionId);
                } else {
                  console.warn(
                    `     ⚠️ Não foi possível mapear a resposta: item_id=${answer.item_id}, option_id=${answer.option_id}`
                  );
                }
              });
            } else {
              console.log(`   - Sem respostas de habilidades para este aluno`);
            }
          });
        } else {
          console.warn(
            "⚠️ Resposta da API não contém success=true ou data está vazio"
          );
        }

        console.log("\n📊 Estado FINAL do studentsAnswers:", initialAnswers);

        // Log resumido por aluno
        Object.keys(initialAnswers).forEach(studentId => {
          const answered = Object.entries(initialAnswers[studentId]).filter(
            ([_, value]) => value !== "nao-avaliado"
          );
          console.log(
            `Aluno ${studentId}: ${answered.length} habilidades avaliadas de ${
              Object.keys(initialAnswers[studentId]).length
            }`
          );
        });

        this.setState({ studentsAnswers: initialAnswers });
      } else {
        console.warn("⚠️ students ou thematicUnits vazio:", {
          studentsLength: this.state.students.length,
          thematicUnitsLength: thematicUnits.length
        });
      }
    } catch (error) {
      console.error("❌ Erro em loadRoomExecutions:", error);
      console.error("Detalhes:", error.response?.data);
      toastr.error("Erro", "Erro ao carregar avaliações dos alunos");
    }
  };

  async loadData() {
    this.setState({ loading: true });

    try {
      const allocationId = parseInt(window.location.pathname.split("/")[3]);
      this.setState({ allocationId });

      const { user } = this.props;
      const hasAdminRole = (user.user_roles || []).some(roleObj =>
        [1, 2, 3, 4, 5].includes(roleObj.role_id)
      );
      this.setState({ isViewOnlyMode: hasAdminRole });

      const allocationData = await this.loadAllocationInfo(allocationId);

      if (allocationData?.roomId && allocationData?.followUpId) {
        // Carregar lista de alunos primeiro
        await this.loadStudentsList(allocationData.roomId);

        // Carregar questões e execuções em paralelo
        const questionData = await this.loadQuestionList(
          allocationData.followUpId
        );
        await this.loadRoomExecutions(allocationId, questionData);

        // Buscar informações complementares (PCD e alfabetizado) em background
        this.loadStudentsComplementaryInfo();
      }
    } catch (error) {
      toastr.error("Erro", "Erro ao carregar dados");
    } finally {
      this.setState({ loading: false });
    }
  }

  loadStudentsList = async roomId => {
    try {
      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/students/list`,
        {
          params: { room_id: roomId },
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      if (response.data?.success) {
        const students = response.data.data || [];
        this.setState({ students });
      } else {
        toastr.error("Erro", "Resposta inválida ao carregar estudantes");
      }
    } catch (error) {
      console.error("Erro em loadStudentsList:", error);
      toastr.error("Erro", "Erro ao carregar lista de estudantes");
      throw error;
    }
  };

  loadStudentsComplementaryInfo = async () => {
    const { students } = this.state;
    const { user } = this.props;

    if (!students.length) {
      console.warn(
        "Nenhum aluno encontrado para buscar informações complementares."
      );
      return;
    }

    // Inicializa com valores padrão: PCD false, Alfabetizado false
    const pcdInfoTemp = {};
    const alfabetizadoInfoTemp = {};

    students.forEach(student => {
      pcdInfoTemp[student.student_id] = {
        pcd: false,
        cid: null,
        hasReport: false
      };
      alfabetizadoInfoTemp[student.student_id] = false; // ← ALTERADO: padrão agora é false
    });

    // Buscar dados em paralelo para todos os alunos
    const promises = students.map(async student => {
      const studentId = student.student_id;

      // Buscar PCD
      try {
        const pcdResponse = await axios.get(
          `${URL.api}access/user-disability/get-by-user`,
          {
            params: { user_id: studentId },
            headers: { authorization: `Bearer ${user.token}` },
            timeout: 10000
          }
        );

        if (pcdResponse.data?.data && pcdResponse.data.data !== null) {
          pcdInfoTemp[studentId] = {
            pcd: pcdResponse.data.data.pcd === true,
            cid: pcdResponse.data.data.cid || null,
            hasReport: pcdResponse.data.data.has_report === true
          };
        }
        // Caso contrário, mantém false (padrão)
      } catch (error) {
        // Mantém false
      }

      // Buscar complemento (alfabetizado)
      try {
        const complementResponse = await axios.get(
          `${URL.api}pedagogical/follow-ups/user-complement`,
          {
            params: { user_id: studentId },
            headers: { authorization: `Bearer ${user.token}` },
            timeout: 10000
          }
        );

        if (
          complementResponse.data?.data &&
          complementResponse.data.data !== null
        ) {
          // Se existir registro, usa o valor real
          alfabetizadoInfoTemp[studentId] =
            complementResponse.data.data.is_literate === true;
        }
        // Se data for null, mantém false (padrão)
      } catch (error) {
        // Mantém false
      }
    });

    await Promise.all(promises);

    this.setState({
      studentPCDInfo: pcdInfoTemp,
      studentAlfabetizadoInfo: alfabetizadoInfoTemp
    });
  };

  findHabilidadeByItemId = itemId => {
    for (const unit of this.state.thematicUnits) {
      const item = unit.items?.find(i => i.item_id === itemId);
      if (item) {
        return {
          codigo: item.ability_code,
          nome: item.ability_name,
          descricao: item.description,
          item_id: item.item_id
        };
      }
    }
    return null;
  };

  getStatusFromOptionId = (optionId, habilidade) => {
    if (!habilidade.options) return "nao-avaliado";

    const option = habilidade.options.find(o => o.id === parseInt(optionId));
    if (!option) return "nao-avaliado";

    const title = option.title;
    if (title.includes("Não desenvolveu")) return "nao-desenvolveu";
    if (title.includes("Desenvolveu parcialmente"))
      return "desenvolveu-parcialmente";
    if (title.includes("Desenvolveu")) return "desenvolveu";

    return "nao-avaliado";
  };

  getAllHabilidades = () => {
    const habilidades = [];
    const uniqueCodes = new Set();

    this.state.thematicUnits.forEach(unit => {
      if (unit.items) {
        unit.items.forEach(item => {
          // Evitar duplicatas
          if (uniqueCodes.has(item.ability_code)) return;
          uniqueCodes.add(item.ability_code);

          const optionsMap = {};
          item.options.forEach(opt => {
            if (opt.title.includes("Não desenvolveu")) {
              optionsMap["nao-desenvolveu"] = opt.id;
            } else if (opt.title.includes("Desenvolveu parcialmente")) {
              optionsMap["desenvolveu-parcialmente"] = opt.id;
            } else if (opt.title.includes("Desenvolveu")) {
              optionsMap.desenvolveu = opt.id;
            }
          });

          habilidades.push({
            codigo: item.ability_code,
            nome: item.ability_name,
            descricao: item.description,
            item_id: item.item_id,
            options: item.options,
            optionsMap
          });
        });
      }
    });
    return habilidades;
  };

  getUnitColor = index => {
    const colors = ["#b3d9ff", "#ffcc99", "#d4f4dd", "#ffb3d9", "#d9b3ff"];
    return colors[index % colors.length];
  };

  toggleCardCollapse = () => {
    this.setState(prevState => ({
      isCardCollapsed: !prevState.isCardCollapsed
    }));
  };

  handleAnswerChange = (studentId, habilidadeCodigo, value) => {
    if (this.state.isViewOnlyMode) return;

    this.setState(prevState => ({
      studentsAnswers: {
        ...prevState.studentsAnswers,
        [studentId]: {
          ...prevState.studentsAnswers[studentId],
          [habilidadeCodigo]: value
        }
      }
    }));
  };

  getStatusStyle = (studentId, habilidadeCodigo) => {
    const status =
      this.state.studentsAnswers[studentId]?.[habilidadeCodigo] ||
      "nao-avaliado";

    switch (status) {
      case "desenvolveu":
        return {
          backgroundColor: "#d4edda",
          color: "#155724",
          fontWeight: "bold"
        };
      case "desenvolveu-parcialmente":
        return {
          backgroundColor: "#fff3cd",
          color: "#856404",
          fontWeight: "bold"
        };
      case "nao-desenvolveu":
        return {
          backgroundColor: "#f8d7da",
          color: "#721c24",
          fontWeight: "bold"
        };
      default:
        return { backgroundColor: "#f8f9fa", color: "#6c757d" };
    }
  };

  getDropdownClass = (studentId, habilidadeCodigo) => {
    const optionId = this.state.studentsAnswers[studentId]?.[habilidadeCodigo];

    if (!optionId || optionId === "nao-avaliado") {
      return "";
    }

    // Buscar a habilidade para obter as opções
    const habilidades = this.getAllHabilidades();
    const habilidade = habilidades.find(h => h.codigo === habilidadeCodigo);
    if (!habilidade || !habilidade.options) {
      return "";
    }

    const option = habilidade.options.find(
      o => o.id === parseInt(optionId, 10)
    );
    if (!option) {
      return "";
    }

    const title = option.title;
    if (title.includes("Não desenvolveu")) {
      return "dropdown-nao-desenvolveu";
    }
    if (title.includes("Desenvolveu parcialmente")) {
      return "dropdown-parcialmente";
    }
    if (title.includes("Desenvolveu")) {
      return "dropdown-desenvolveu";
    }
    return "";
  };

  getOptionIdFromStatus = (status, habilidadeCodigo) => {
    const habilidades = this.getAllHabilidades();
    const habilidade = habilidades.find(h => h.codigo === habilidadeCodigo);
    return habilidade?.optionsMap?.[status] || null;
  };

  // Handlers para Alfabetizado
  handleToggleAlfabetizado = async student => {
    const studentId = student.student_id;
    const { isViewOnlyMode, studentAlfabetizadoInfo } = this.state;
    const { user } = this.props;

    if (isViewOnlyMode) {
      toastr.warning(
        "Atenção",
        "Você não tem permissão para alterar essas informações."
      );
      return;
    }

    const currentValue = studentAlfabetizadoInfo[studentId] ?? true;
    const newValue = !currentValue;

    this.setState(prevState => ({
      updatingStudentAlfabetizado: {
        ...prevState.updatingStudentAlfabetizado,
        [studentId]: true
      }
    }));

    try {
      const payload = {
        user_id: studentId,
        is_literate: newValue
      };

      const response = await axios.post(
        `${URL.api}access/user_complement/upsert`,
        payload,
        { headers: { authorization: `Bearer ${user.token}` } }
      );

      if (!response.data?.success) {
        throw new Error(
          response.data?.error || "Erro ao atualizar alfabetizado"
        );
      }

      this.setState(prevState => ({
        studentAlfabetizadoInfo: {
          ...prevState.studentAlfabetizadoInfo,
          [studentId]: newValue
        }
      }));

      toastr.success(
        "Sucesso",
        `Status de alfabetização atualizado com sucesso!`
      );
    } catch (error) {
      console.error("Erro ao persistir alfabetizado:", error);
      toastr.error(
        "Erro",
        error.response?.data?.error ||
          error.message ||
          "Erro ao atualizar alfabetizado"
      );
    } finally {
      this.setState(prevState => ({
        updatingStudentAlfabetizado: {
          ...prevState.updatingStudentAlfabetizado,
          [studentId]: false
        }
      }));
    }
  };

  // Handlers para PCD
  handleTogglePCD = student => {
    const { isViewOnlyMode, studentPCDInfo } = this.state;

    if (isViewOnlyMode) {
      toastr.warning(
        "Atenção",
        "Você não tem permissão para alterar essas informações."
      );
      return;
    }

    const currentValue = studentPCDInfo[student.student_id]?.pcd || false;
    const newValue = !currentValue;

    if (newValue === true) {
      // Abrir modal para perguntar sobre laudo
      this.setState({
        showPCDModal: true,
        showCIDInput: false,
        cidValue: "",
        currentPCDStudent: student
      });
    } else {
      // Desativar PCD diretamente
      this.updatePCDStatus(student, false, null);
    }
  };

  updatePCDStatus = async (student, pcdValue, cidValue, hasReportValue) => {
    const studentId = student.student_id;
    const { user } = this.props;

    this.setState(prevState => ({
      updatingStudentPCD: {
        ...prevState.updatingStudentPCD,
        [studentId]: true
      }
    }));

    try {
      const payload = {
        user_id: studentId,
        pcd: pcdValue,
        cid: cidValue,
        has_report: hasReportValue
      };

      const response = await axios.post(
        `${URL.api}access/user-disability/upsert`,
        payload,
        { headers: { authorization: `Bearer ${user.token}` } }
      );

      if (!response.data?.success) {
        throw new Error(response.data?.error || "Erro ao atualizar PCD");
      }

      this.setState(prevState => ({
        studentPCDInfo: {
          ...prevState.studentPCDInfo,
          [studentId]: {
            pcd: pcdValue,
            cid: cidValue,
            hasReport: hasReportValue
          }
        }
      }));

      toastr.success("Sucesso", "Informação de PCD atualizada com sucesso!");
    } catch (error) {
      console.error("Erro ao persistir PCD:", error);
      toastr.error(
        "Erro",
        error.response?.data?.error || error.message || "Erro ao atualizar PCD"
      );
    } finally {
      this.setState(prevState => ({
        updatingStudentPCD: {
          ...prevState.updatingStudentPCD,
          [studentId]: false
        }
      }));
    }
  };

  handlePCDModalComLaudo = () => {
    const { showCIDInput, cidValue, currentPCDStudent } = this.state;

    if (!showCIDInput) {
      this.setState({ showCIDInput: true });
      return;
    }

    // Remove a validação que exigia o CID
    // if (!cidValue || cidValue.trim() === "") {
    //   toastr.warning("Atenção", "Por favor, informe o CID do laudo.");
    //   return;
    // }

    this.setState({ showPCDModal: false, showCIDInput: false });
    // Se o CID não for informado, envia null (ou vazio, conforme o backend esperar)
    const cidToSend = cidValue?.trim() || null;
    this.updatePCDStatus(currentPCDStudent, true, cidToSend, true);
  };

  handlePCDModalSemLaudo = () => {
    const { currentPCDStudent } = this.state;
    this.setState({ showPCDModal: false, showCIDInput: false });
    this.updatePCDStatus(currentPCDStudent, true, null, false);
  };

  handleClosePCDModal = () => {
    this.setState({
      showPCDModal: false,
      showCIDInput: false,
      cidValue: "",
      currentPCDStudent: null
    });
  };

  handleSaveExecution = async () => {
    const {
      studentsAnswers,
      students,
      allocationId,
      thematicUnits,
      studentAlfabetizadoInfo
    } = this.state;
    const { user } = this.props;

    let hasAnyAnswer = false;
    Object.values(studentsAnswers).forEach(studentAnswers => {
      Object.values(studentAnswers).forEach(answer => {
        if (
          answer !== "nao-avaliado" &&
          answer &&
          !Number.isNaN(parseInt(answer, 10))
        ) {
          hasAnyAnswer = true;
        }
      });
    });

    if (!hasAnyAnswer) {
      toastr.warning(
        "Atenção",
        "É necessário avaliar pelo menos uma habilidade para algum aluno antes de salvar."
      );
      return;
    }

    this.setState({ saving: true });

    try {
      // --- 1. Garantir que alunos não alfabetizados sejam persistidos como false ---
      const nonLiterateStudents = students.filter(
        student => studentAlfabetizadoInfo[student.student_id] === false
      );

      const alfabetizacaoPromises = nonLiterateStudents.map(async student => {
        const payload = {
          user_id: student.student_id,
          is_literate: false
        };
        const response = await axios.post(
          `${URL.api}access/user_complement/upsert`,
          payload,
          { headers: { authorization: `Bearer ${user.token}` } }
        );
        if (!response.data?.success) {
          throw new Error(
            response.data?.error ||
              `Erro ao definir não alfabetizado para ${student.full_name}`
          );
        }
        return true;
      });

      if (alfabetizacaoPromises.length > 0) {
        await Promise.all(alfabetizacaoPromises);
      }

      // --- 2. Salvar respostas das habilidades (lógica original) ---
      const habilidadeToItemMap = {};
      thematicUnits.forEach(unit => {
        if (unit.items) {
          unit.items.forEach(item => {
            habilidadeToItemMap[item.ability_code] = {
              item_id: item.item_id,
              options: item.options || []
            };
          });
        }
      });

      let savedCount = 0;
      let errorCount = 0;
      const errorsList = [];

      for (const student of students) {
        const studentId = student.student_id;
        const studentAnswersData = studentsAnswers[studentId] || {};

        const answers = [];

        Object.keys(studentAnswersData).forEach(habilidadeCodigo => {
          const statusOrOptionId = studentAnswersData[habilidadeCodigo];

          if (statusOrOptionId !== "nao-avaliado") {
            const itemInfo = habilidadeToItemMap[habilidadeCodigo];
            if (itemInfo) {
              const optionId = parseInt(statusOrOptionId, 10);

              if (!Number.isNaN(optionId)) {
                answers.push({
                  item_id: itemInfo.item_id,
                  option_id: optionId,
                  free_text: null
                });
              }
            }
          }
        });

        if (answers.length > 0) {
          const payload = {
            allocation_id: allocationId,
            student_id: studentId,
            teacher_id: user.user.id,
            answers
          };

          try {
            const response = await axios.post(
              `${URL.api}pedagogical/follow-ups/executions/save`,
              payload,
              { headers: { authorization: `Bearer ${user.token}` } }
            );

            if (response.data.success) {
              savedCount += 1;
            } else {
              errorCount += 1;
              errorsList.push({
                student: student.full_name || studentId,
                error: response.data.message
              });
            }
          } catch (error) {
            errorCount += 1;
            errorsList.push({
              student: student.full_name || studentId,
              error: error.response?.data?.message || error.message
            });
          }
        }
      }

      if (savedCount > 0 && errorCount === 0) {
        toastr.success(
          "Sucesso",
          `Acompanhamento pedagógico salvo com sucesso para ${savedCount} aluno(s)!`
        );
        setTimeout(() => {
          this.loadData();
        }, 1500);
      } else if (savedCount > 0 && errorCount > 0) {
        toastr.warning(
          "Atenção",
          `${savedCount} aluno(s) salvos com sucesso, ${errorCount} erro(s) encontrados.`
        );
        if (process.env.NODE_ENV === "development") {
          console.error("Erros ao salvar:", errorsList);
        }
      } else {
        toastr.error(
          "Erro",
          errorsList[0]?.error || "Erro ao salvar acompanhamento pedagógico."
        );
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Erro ao atualizar status de alfabetização ou salvar acompanhamento.";
      toastr.error("Erro", errorMessage);
    } finally {
      this.setState({ saving: false });
    }
  };

  handleDownloadPDF = async () => {
    const { followUpId } = this.state;

    if (!followUpId) {
      toastr.warning("Atenção", "ID do planejamento não disponível.");
      return;
    }

    try {
      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/${followUpId}/download-pdf`,
        {
          responseType: "blob",
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 100);

      toastr.success("Sucesso", "PDF aberto em nova aba.");
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      toastr.error("Erro", "Não foi possível abrir o PDF.");
    }
  };

  render() {
    const {
      allocationInfo,
      students,
      thematicUnits,
      loading,
      studentPCDInfo,
      studentAlfabetizadoInfo,
      updatingStudentPCD,
      updatingStudentAlfabetizado,
      isViewOnlyMode,
      saving
    } = this.state;
    const habilidades = this.getAllHabilidades();

    const breadcrumbItems = [
      {
        path: "/pedagogical-follow-ups",
        to: "/pedagogical-follow-ups",
        name: "Acompanhamento Pedagógico"
      }
    ];

    if (loading) {
      return (
        <>
          <Breadcrumb
            current={this.props.currentRoute}
            items={breadcrumbItems}
          />
          <div className="p-4">
            <Loading />
          </div>
          <ProtectedRoute routeId={this.props.currentRoute} />
        </>
      );
    }

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} items={breadcrumbItems} />
        <div className="mt-0 execution-room-pedagogical-followups">
          <div
            className={`card shadow-sm ${
              this.state.isCardCollapsed ? "collapsed" : ""
            }`}
          >
            <div
              className="card-header bg-light text-dark d-flex align-items-center"
              onClick={this.toggleCardCollapse}
              style={{ cursor: "pointer" }}
            >
              <div className="mr-2">
                {this.state.isCardCollapsed ? (
                  <ChevronRight size={20} />
                ) : (
                  <ChevronDown size={20} />
                )}
              </div>
              {this.state.isCardCollapsed ? (
                <div className="d-flex align-items-center w-100">
                  <div className="flex-grow-1">
                    <h5 className="mb-0">
                      {allocationInfo?.name || "Acompanhamento Pedagógico"}
                    </h5>
                    <small className="text-white">
                      {allocationInfo?.room_name || "Carregando..."}
                    </small>
                  </div>
                </div>
              ) : (
                <h5 className="mb-0 d-flex align-items-center">
                  Acompanhamento Pedagógico - Turma
                </h5>
              )}
            </div>
            {!this.state.isCardCollapsed && (
              <div className="card-body">
                <div className="row">
                  <div className="col-md-3 mb-3">
                    <label className="form-label font-weight-bold text-muted">
                      Acompanhamento
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm form-input-readonly"
                      value={allocationInfo?.name || "Carregando..."}
                      readOnly
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label font-weight-bold text-muted">
                      Turma
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm form-input-readonly"
                      value={allocationInfo?.room_name || "Carregando..."}
                      readOnly
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label font-weight-bold text-muted">
                      Escola
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm form-input-readonly"
                      value={allocationInfo?.school_name || "Carregando..."}
                      readOnly
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label font-weight-bold text-muted">
                      Disciplina
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm form-input-readonly"
                      value={allocationInfo?.discipline_name || "Carregando..."}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="card shadow-sm mt-3">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Acompanhamento das Habilidades</h5>
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={this.handleDownloadPDF}
              >
                Obter Ajuda
              </button>
            </div>
            <div className="card-body-table">
              <div className="mb-3">
                <h6 className="font-weight-bold text-muted mb-2">Legenda:</h6>
                <div className="d-flex flex-wrap gap-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="legend-color-circle"
                      style={{ backgroundColor: "#d4edda" }}
                    ></div>
                    <small className="text-muted">Desenvolveu</small>
                  </div>
                  <div className="d-flex align-items-center">
                    <div
                      className="legend-color-circle"
                      style={{ backgroundColor: "#fff3cd" }}
                    ></div>
                    <small className="text-muted">
                      Desenvolveu Parcialmente
                    </small>
                  </div>
                  <div className="d-flex align-items-center">
                    <div
                      className="legend-color-circle"
                      style={{ backgroundColor: "#f8d7da" }}
                    ></div>
                    <small className="text-muted">Não Desenvolveu</small>
                  </div>
                  <div className="d-flex align-items-center">
                    <div
                      className="legend-color-circle"
                      style={{ backgroundColor: "#f8f9fa" }}
                    ></div>
                    <small className="text-muted">Não Avaliado</small>
                  </div>
                </div>
              </div>
              <div className="table-responsive table-scroll-container table-container-custom">
                <table className="table table-bordered mb-0 table-custom">
                  <thead className="thead-light">
                    {/* Primeira linha - Unidades Temáticas */}
                    <tr className="unidades-tematicas-row">
                      <th
                        className="unidade-tematica-header"
                        style={{
                          backgroundColor: "#F8F9FA",
                          position: "relative",
                          zIndex: 1
                        }}
                      >
                        ESTUDANTE
                      </th>
                      <th
                        className="unidade-tematica-header"
                        style={{
                          backgroundColor: "#F8F9FA",
                          position: "relative",
                          zIndex: 1
                        }}
                      >
                        ALFABETIZADO
                      </th>
                      <th
                        className="unidade-tematica-header"
                        style={{
                          backgroundColor: "#F8F9FA",
                          position: "relative",
                          zIndex: 1
                        }}
                      >
                        PCD
                      </th>
                      {thematicUnits.map((unit, index) => (
                        <th
                          key={unit.thematic_unit_id}
                          className="unidade-tematica-header"
                          colSpan={unit.items?.length || 0}
                          style={{
                            backgroundColor: this.getUnitColor(index),
                            position: "relative",
                            zIndex: 1
                          }}
                        >
                          {unit.thematic_unit_name}
                        </th>
                      ))}
                    </tr>

                    {/* Segunda linha - Habilidades */}
                    <tr className="disciplina-row">
                      <th
                        className="habilidade-header habilidade-column"
                        style={{
                          position: "sticky",
                          top: 0,
                          left: 0,
                          zIndex: 60,
                          backgroundColor: "#f8f9fa",
                          minWidth: "200px"
                        }}
                      >
                        CÓDIGO E DESCRIÇÃO DA HABILIDADE
                        <br /> (CURRÍCULO PE)
                      </th>
                      <th
                        className="habilidade-header"
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 50,
                          backgroundColor: "#f8f9fa",
                          minWidth: "120px"
                        }}
                      >
                        Status
                      </th>
                      <th
                        className="habilidade-header"
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 50,
                          backgroundColor: "#f8f9fa",
                          minWidth: "120px"
                        }}
                      >
                        Status
                      </th>
                      {thematicUnits.map(unit =>
                        unit.items?.map(item => (
                          <th
                            key={item.item_id}
                            className="habilidade-header habilidade-column"
                            title={item.description}
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 50,
                              backgroundColor: "#f8f9fa",
                              height: "auto",
                              minHeight: "100px",
                              minWidth: "200px"
                            }}
                          >
                            <div
                              className="habilidade-text"
                              style={{ transform: "none" }}
                            >
                              <strong>{item.ability_code}</strong>
                              <br />
                              <span className="habilidade-nome">
                                {item.ability_name}
                              </span>
                            </div>
                          </th>
                        ))
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {students.map((student, index) => {
                      const studentId = student.student_id;
                      const isAlfabetizado =
                        studentAlfabetizadoInfo[studentId] ?? false;
                      const pcdInfo = studentPCDInfo[studentId] || {
                        pcd: false,
                        cid: null
                      };
                      const isUpdatingAlf =
                        updatingStudentAlfabetizado[studentId] || false;
                      const isUpdatingPCD =
                        updatingStudentPCD[studentId] || false;

                      return (
                        <tr key={studentId} data-group={(index % 2) + 1}>
                          <td
                            className={`student-cell ${
                              index % 2 === 0
                                ? "student-cell-white"
                                : "student-cell-gray"
                            }`}
                            style={{ minWidth: "200px" }}
                          >
                            {student.full_name ||
                              `${student.student_name} ${
                                student.student_surname || ""
                              }`.trim()}
                          </td>
                          <td
                            className="text-center"
                            style={{ minWidth: "120px" }}
                          >
                            <div className="custom-control custom-switch d-inline-block">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`alf-${studentId}`}
                                checked={isAlfabetizado}
                                onChange={() =>
                                  this.handleToggleAlfabetizado(student)
                                }
                                disabled={isViewOnlyMode || isUpdatingAlf}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`alf-${studentId}`}
                              />
                            </div>
                            {isUpdatingAlf && (
                              <small className="text-muted ml-1">...</small>
                            )}
                          </td>
                          <td
                            className="text-center"
                            style={{ minWidth: "120px" }}
                          >
                            <div className="custom-control custom-switch d-inline-block">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`pcd-${studentId}`}
                                checked={pcdInfo.pcd || false}
                                onChange={() => this.handleTogglePCD(student)}
                                disabled={isViewOnlyMode || isUpdatingPCD}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`pcd-${studentId}`}
                              />
                            </div>
                            {isUpdatingPCD && (
                              <small className="text-muted ml-1">...</small>
                            )}
                          </td>
                          {habilidades.map(habilidade => {
                            const currentValue =
                              this.state.studentsAnswers[studentId]?.[
                                habilidade.codigo
                              ] || "nao-avaliado";
                            return (
                              <td
                                key={`${studentId}-${habilidade.codigo}`}
                                className="text-center p-2"
                                style={{ minWidth: "200px" }}
                              >
                                <select
                                  className={`form-control form-control-sm select-custom ${this.getDropdownClass(
                                    studentId,
                                    habilidade.codigo
                                  )}`}
                                  value={currentValue}
                                  onChange={e => {
                                    const newValue = e.target.value;
                                    this.handleAnswerChange(
                                      studentId,
                                      habilidade.codigo,
                                      newValue
                                    );
                                  }}
                                  disabled={isViewOnlyMode}
                                >
                                  <option value="nao-avaliado">
                                    Não Avaliado
                                  </option>
                                  {habilidade.options.map(opt => (
                                    <option key={opt.id} value={String(opt.id)}>
                                      {opt.title}
                                    </option>
                                  ))}
                                </select>
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={this.handleSaveExecution}
                  disabled={saving || isViewOnlyMode}
                >
                  {saving ? "Salvando..." : "Salvar Acompanhamento"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Modal PCD */}
        <Modal
          isOpen={this.state.showPCDModal}
          toggle={this.handleClosePCDModal}
          centered
        >
          <ModalHeader toggle={this.handleClosePCDModal}>
            Estudante com Deficiência
          </ModalHeader>
          <ModalBody>
            {!this.state.showCIDInput ? (
              <p className="p-3 m-0">
                O estudante possui laudo médico com CID?
              </p>
            ) : (
              <div className="form-group p-3 m-0">
                CID do Laudo{" "}
                <span className="text-muted font-weight-normal">
                  (opcional)
                </span>
                <input
                  type="text"
                  className="form-control"
                  id="cidInput"
                  placeholder="Ex: F84.0, G80.0, etc."
                  value={this.state.cidValue}
                  onChange={e => this.setState({ cidValue: e.target.value })}
                />
                <small className="form-text text-muted">
                  Informe o código CID do laudo médico.
                </small>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.handleClosePCDModal}>
              Cancelar
            </Button>
            {!this.state.showCIDInput ? (
              <>
                <Button color="warning" onClick={this.handlePCDModalSemLaudo}>
                  Sem Laudo
                </Button>
                <Button color="primary" onClick={this.handlePCDModalComLaudo}>
                  Com Laudo
                </Button>
              </>
            ) : (
              <Button color="primary" onClick={this.handlePCDModalComLaudo}>
                Salvar
              </Button>
            )}
          </ModalFooter>
        </Modal>

        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExecutionRoomPedagogicalFollowUps);
